import React from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Select from 'react-select';

//ReportDropdown to show as Report drop-down on nav-bar
const ReportDropdown = props => {
  const { navigate } = props;
  const { t } = useTranslation();

  const urlInfo = window.location.toString().split('/');
  const linkText = urlInfo.pop();

  //Custom style for drop-down
  const Styles = {
    control: styles => {
      return {
        ...styles,
        backgroundColor: 'transparent',
        border: 'none',
        // This line disables the blue border
        boxShadow: 'none',
        cursor: 'pointer',
        padding: 0,
      };
    },
    menu: defaultStyles => {
      return {
        ...defaultStyles,
        width: '300px',
      };
    },
    dropdownIndicator: defaultStyles => {
      return {
        ...defaultStyles,
        position: 'relative',
        right: '8px',
        padding: 0,
      };
    },
    placeholder: defaultStyles => {
      return {
        ...defaultStyles,
        color: linkText === 'DetailedList' ? 'white' : 'rgba(255,255,255,.55)',
      };
    },
  };

  //options for drop-down
  const reportOptions = [
    {
      label: t('PECR_Detailed_List'),
      value: 'PECR_Detailed_List',
    },
  ];

  //To handle the onchange of drop-down
  const handleChange = event => {
    if (event.value === 'PECR_Detailed_List') {
      navigate('/DetailedList');
    }
  };

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <ArrowDropDownIcon
          style={{
            color:
              linkText === 'DetailedList' ? 'white' : 'rgba(255,255,255,.55)',
            fontSize: 40,
          }}
        />
      </components.DropdownIndicator>
    );
  };

  return (
    <Select
      onChange={handleChange}
      options={reportOptions}
      styles={Styles}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator,
      }}
      value={t('Reports')}
      placeholder={t('Reports')}
      isSearchable={false}
    />
  );
};

export default ReportDropdown;
